import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { collaborateWays } from "@/mocks/collaborateData";

const wayRoutes: Record<string, string> = {
  "Technology Partner": "/technology-partners",
};

export default function CollaborateWays() {
  return (
    <section id="ways" className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Collaboration Pathways
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                Six Ways to Partner With TIE
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                TIE collaborates with factories, technology partners, researchers, academics, buyers, and sponsors. Each pathway is designed to create mutual value.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {collaborateWays.map((way, index) => {
              const route = wayRoutes[way.type];
              const cardContent = (
                <div className="group h-full p-5 md:p-6 rounded-xl bg-tie-grey-light border border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-lg transition-all duration-300">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal flex items-center justify-center shrink-0">
                      <i className={`${way.icon} text-white text-base`} />
                    </div>
                    <div>
                      <span className="text-xs font-bold text-tie-teal uppercase tracking-wider">
                        {way.type}
                      </span>
                      <h3 className="text-base md:text-lg font-semibold text-tie-text-primary">
                        {way.title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-sm text-tie-text-secondary leading-relaxed mb-4">
                    {way.description}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {way.programmes.map((prog) => (
                      <span
                        key={prog}
                        className="inline-flex items-center px-2.5 py-1 rounded-full bg-white border border-tie-grey-dark text-xs text-tie-text-secondary"
                      >
                        {prog}
                      </span>
                    ))}
                  </div>
                  {route && (
                    <div className="mt-4 pt-3 border-t border-tie-grey-dark">
                      <span className="inline-flex items-center text-sm font-medium text-tie-teal">
                        Explore directory
                        <i className="ri-arrow-right-line ml-1.5 group-hover:translate-x-1 transition-transform" />
                      </span>
                    </div>
                  )}
                </div>
              );
              return (
                <ScrollReveal key={way.type} delay={index * 100}>
                  {route ? (
                    <Link to={route} className="block cursor-pointer">
                      {cardContent}
                    </Link>
                  ) : (
                    cardContent
                  )}
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}